import { createTheme } from "@mui/material/styles";
import { colors } from "./colors";

export let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1000,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: "Montserrat",
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "contained" },
          style: {
            background: colors.purple[500],
            "&:hover": { background: colors.purpleAlpha[800] },
          },
        },
        {
          props: { variant: "outlined" },
          style: {
            border: `1px solid ${colors.purple[500]}`,
            borderRadius: 30,
            padding: "10px 15px 10px 15px",
            color: colors.purple[500],
            "&:hover": { background: colors.purpleAlpha[800] },
          },
        },
      ],
    },
  },
});

theme.typography.h1 = {
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "20px",
  },
  fontFamily: "Montserrat",
  fontWeight: 500,
};

theme.typography.h2 = {
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "16px",
  },
  fontFamily: "Montserrat",
  fontWeight: 400,
};
